export class ApiError extends Error {
  code: string;
  status: number;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

export interface ApiInit { method?: 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT'; body?: unknown; signal?: AbortSignal }

/** JSON fetch against the server contract. Cookies ride along; errors become ApiError. */
export async function api<T>(path: string, init: ApiInit = {}): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? (init.body !== undefined ? 'POST' : 'GET'),
    credentials: 'include',
    headers: init.body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    signal: init.signal,
  });
  if (!res.ok) {
    let code = 'http_error';
    let message = `${res.status} ${res.statusText}`;
    try {
      const j = (await res.json()) as { error?: { code?: string; message?: string } };
      if (j?.error) { code = j.error.code ?? code; message = j.error.message ?? message; }
    } catch { /* not JSON */ }
    throw new ApiError(res.status, code, message);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const isUnauthorized = (e: unknown): boolean => e instanceof ApiError && e.status === 401;
